// Sesion de una SPA del pool administrativo (torre, portal del proveedor).
// Mudado desde apps/tower/src/auth/session.ts sin cambiar el comportamiento:
// lo unico nuevo es que la clave del storage la elige cada SPA, porque cada
// una vive en su propio dominio y no comparte estado con las otras.
//
// Dos niveles con distinta sensibilidad:
//   - memoria (`enMemoria`): la sesion completa, refresh token incluido;
//   - sessionStorage: SOLO el ID token y lo minimo para reconstruir la sesion
//     al recargar (email, expiracion). El refresh token NUNCA se persiste
//     (auditoria 2026-09-20, A1): un refresh en storage vale un turno entero
//     ante cualquier script que lo lea; un ID token vale como mucho una hora.
//
// Downgrades aceptados:
//   - al recargar la pestaña se pierde el refresh token: la sesion sigue
//     mientras el ID token valga y, cuando vence, el operador vuelve al login;
//   - en navegadores que bloquean storage (try/catch) la sesion vive solo en
//     memoria y se pierde al recargar.
/** Margen para no usar un token al borde de vencer entre tick y tick. */
const MARGEN_MS = 10_000;
export function sessionValid(session, now = Date.now()) {
    return session.expiraEn * 1000 > now + MARGEN_MS;
}
/** Proyeccion explicita: nada que no este aca llega al storage. */
function aPersistida(session) {
    return {
        accessToken: session.accessToken,
        expiraEn: session.expiraEn,
        user: session.user,
    };
}
/** Validacion defensiva del JSON del storage: solo los tres campos persistidos. */
function validar(parseada) {
    if (typeof parseada !== "object" || parseada === null)
        return null;
    const entry = parseada;
    const accessToken = entry["accessToken"];
    const expiraEn = entry["expiraEn"];
    const user = entry["user"];
    if (typeof accessToken !== "string" ||
        typeof expiraEn !== "number" ||
        !Number.isFinite(expiraEn) ||
        typeof user !== "string") {
        return null;
    }
    return { accessToken, expiraEn, user };
}
export function createSessionStore(storageKey) {
    let enMemoria = null;
    const persistir = (session) => {
        try {
            sessionStorage.setItem(storageKey, JSON.stringify(aPersistida(session)));
        }
        catch {
            // storage bloqueado: seguimos solo en memoria
        }
    };
    return {
        guardar(session) {
            enMemoria = session;
            persistir(session);
        },
        borrar() {
            enMemoria = null;
            try {
                sessionStorage.removeItem(storageKey);
            }
            catch {
                // nada que borrar si el storage no anda
            }
        },
        leer(now = Date.now()) {
            if (enMemoria !== null) {
                return sessionValid(enMemoria, now) ? enMemoria : null;
            }
            try {
                const raw = sessionStorage.getItem(storageKey);
                if (raw === null)
                    return null;
                const parseada = JSON.parse(raw);
                const session = validar(parseada);
                if (session === null || !sessionValid(session, now))
                    return null;
                // Sesiones guardadas por versiones anteriores traian el refresh token:
                // se reescribe la proyeccion limpia para que no quede en el storage.
                if ("refreshToken" in parseada)
                    persistir(session);
                enMemoria = session;
                return session;
            }
            catch {
                return null;
            }
        },
    };
}
//# sourceMappingURL=session.js.map